import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from "@ant-design/icons"
import { Alert } from "antd"
import PropTypes from "prop-types"
import React from "react"
import * as css from "./Info.module.css"

const ICONS = {
  info: InfoCircleFilled,
  success: CheckCircleFilled,
  warning: ExclamationCircleFilled,
  error: CloseCircleFilled,
}

function Info({ title, type = "info", children }) {
  const Icon = ICONS[type] || InfoCircleFilled

  // Title-less admonitions: let antd place the icon inline to the left of the
  // body (the standard callout look) instead of rendering an empty title row —
  // which leaves the icon orphaned on its own line above the content.
  if (!title) {
    return (
      <Alert
        type={type}
        showIcon
        icon={<Icon className={css.icon} aria-hidden="true" />}
        message={children}
        className={css.root}
      />
    )
  }

  return (
    <Alert
      type={type}
      message={
        <span className={css.titleRow}>
          <Icon className={css.icon} aria-hidden="true" />
          <span>{title}</span>
        </span>
      }
      description={children}
      className={css.root}
      showIcon={false}
    />
  )
}

Info.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(["info", "error", "success", "warning"]),
  children: PropTypes.node,
}

export default Info
